module.exports = __webpack_public_path__ + "static/Banner-20-4ca17cf8bc2e3e5088096351a9a75e35.png";